import {useCallback} from 'react';

import {DmsDataGrid} from '@dms/shared';

import type {EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

interface ProbabiltyDataGridProps {
  maximization?: EagGridMaximization;
  serviceCaseId: string;
  orderId: string;
}

export function ProfitabilityDataGrid(props: ProbabiltyDataGridProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({
      ...filter,
      orderId: props.orderId,
    }),
    [props.orderId]
  );

  return (
    <DmsDataGrid
      maximization={props.maximization}
      gridCode="service-order-profitability"
      autoHeight
      queryModifier={queryModifier}
    />
  );
}
